(function () {
    "use strict";


    angular.module('app').directive('habilHelpedDropdownBranchRequired', HabilBranchDropdownWithHelpDirective);
    function HabilBranchDropdownWithHelpDirective() {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                fodbzModel: '=',
                fodbzField: '@',
                fodbzFieldConst: '@',
                branches: '=',
                fodbzInfo: '@',
                fodbzInfoTitle: '@',
                fodbzSizeText: '@'
            },
            template: '<div class="input-group">\
                        <div class="input-group-addon ">\
                            <span data-toggle="popover" \
                                    title="{{fodbzInfo}}" \
                                    data-content="{{fodbzInfo}}" \
                                    style="cursor:pointer" \
                                    data-original-title="{{fodbzInfoTitle}}"> \
                                <span class="glyphicon glyphicon-info-sign"  style="font-size:75%; vertical-align: center;"></span> \
                            </span>\
                        </div> \
                        <select \
                            aria-describedby="{{fodbzFieldConst}}Error"  \
                            class="form-control {{fodbzSizeText}}"  \
                            ng-required="true"  \
                            ng-model="fodbzModel"  \
                            id="{{fodbzFieldConst}}" \
                            name="{{fodbzFieldConst}}" \
                            ng-options="item.BranchNbr as item.BranchDropBoxName for item in branches  | orderBy:\'TypeCode\'"  \
                            required="required"> \
                        </select>\
                    </div>',
        };
    }


})();